import * as React from "react";
import i18n from "i18n";
import GeneralWelcomeMetrics from "components/welcome/GeneralWelcomeMetrics";
import SecurityWelcomeMetrics from "./SecurityWelcomeMetrics";
const securityWelcomeMetrics = [
  {
    get label() {
      return i18n.t("welcome_metrics.tab_security", { ns: "enterprise_security_app" });
    },
    component: SecurityWelcomeMetrics,
    isEnabled: ({ isValidSecurityLicense }) => isValidSecurityLicense
  }
];
const generalWelcomePageMetrics = [
  {
    component: () => /* @__PURE__ */ React.createElement(GeneralWelcomeMetrics, { topSourcesOnly: true }),
    isEnabled: ({ isValidSecurityLicense }) => isValidSecurityLicense
  }
];
const pluginExports = {
  welcomePageMetrics: securityWelcomeMetrics,
  "welcomePageMetrics.general": generalWelcomePageMetrics
};
export default pluginExports;
